export const DurationConst = {
    SECONDS_5: {
        label: '5 Seconds',
        value: '5'
    },
    SECONDS_6: {
        label: '6 Seconds',
        value: '6'
    },
    SECONDS_7: {
        label: '7 Seconds',
        value: '7'
    },
    SECONDS_10: {
        label: '10 Seconds',
        value: '10'
    },
    SECONDS_15: {
        label: '15 Seconds',
        value: '15'
    },
    SECONDS_20: {
        label: '20 Seconds',
        value: '20'
    },
    SECONDS_30: {
        label: '30 Seconds',
        value: '30'
    },
    SECONDS_45: {
        label: '45 Seconds',
        value: '45'
    },
    SECONDS_60: {
        label: '60 Seconds',
        value: '60'
    },
    SECONDS_90: {
        label: '90 Seconds',
        value: '90'
    },
    SECONDS_120: {
        label: '120 Seconds',
        value: '120'
    }
}